import { StyledButton } from 'components/SharedStyledElements';
import { TypographyStyled } from 'components/SubpageHeader/AssetsVouchersSubpageHeader';
import { createAssetFromTemplate, loadTemplates } from 'ducks/merchantDucks/items/actions';
import { getTemplateCollection } from 'ducks/merchantDucks/items/selectors';
import React, { useEffect, useRef, useState } from 'react';
import { HiOutlineTemplate } from 'react-icons/hi';
import { ImMagicWand } from 'react-icons/im';
import { IoMdArrowDropright } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { AnalyticsComponent, AnalyticsEvents, AnalyticsComponentType } from '@inplayer-org/inplayer-ui';
import { PlusIcon } from '../containers/Assets';
import {
  DropdownContainer,
  DropdownList,
  TemplateOptions,
  DropdownItem,
  ViewAll,
  FlexContainer,
  ButtonContainer,
  IconHolder,
} from './Styles';

interface Props {
  showTypeDialog: () => void;
}

const CreateAssetButtonDropdown: React.FC<Props> = ({ showTypeDialog }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showTemplates, setShowTemplates] = useState(false);

  const templates = useSelector(getTemplateCollection).slice(0, 3);

  const reference = useRef<HTMLDivElement>(null);
  const templatesRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const listener = (event: any) => {
      if (!containerRef.current || containerRef.current.contains(event.target)) {
        return;
      }
      if (!reference.current || reference.current.contains(event.target)) {
        return;
      }

      if (templatesRef.current && templatesRef.current.contains(event.target)) {
        return;
      }

      setShowTemplates(false);
      setShowDropdown(false);
    };

    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [containerRef, reference, templatesRef]);

  useEffect(() => {
    dispatch(loadTemplates());
  }, []);

  const handleButtonClick = () => {
    setShowDropdown(true);
  };

  const handleHover = (value: boolean) => {
    setShowTemplates(value);
  };

  const handleCreateAssetFromTemplate = (templateId: number) => {
    dispatch(createAssetFromTemplate(templateId));
  };

  return (
    <FlexContainer>
      <TypographyStyled variant="h1">Your assets</TypographyStyled>
      <ButtonContainer>
        <StyledButton tag="button_new_asset" width="10rem" padding="0.8rem" onClick={handleButtonClick}>
          <PlusIcon>+</PlusIcon>
          New asset
        </StyledButton>
        {showDropdown && (
          <DropdownContainer>
            <DropdownList ref={containerRef}>
              <DropdownItem tag="button_template" onMouseEnter={() => handleHover(true)} ref={reference}>
                <IconHolder>
                  <HiOutlineTemplate />
                </IconHolder>
                From template
                <IconHolder>
                  <IoMdArrowDropright />
                </IconHolder>
              </DropdownItem>
              <AnalyticsComponent>
                {({ pages, tracker, merchantId, ip }) => (
                  <DropdownItem
                    tag="button_custom_creation"
                    onMouseEnter={() => setShowTemplates(false)}
                    onClick={() => {
                      showTypeDialog();
                      tracker.track({
                        event: 'click',
                        type: 'button',
                        tag: 'button_custom_creation',
                        pages,
                        merchantId,
                        ip,
                      });
                    }}
                  >
                    <IconHolder>
                      <ImMagicWand />
                    </IconHolder>
                    Custom creation
                  </DropdownItem>
                )}
              </AnalyticsComponent>
            </DropdownList>
            {showTemplates && (
              <TemplateOptions ref={templatesRef}>
                {templates.map((template) => {
                  const { id, name } = template;
                  return (
                    <DropdownItem
                      tag={`button_template_${name}`}
                      key={id}
                      onClick={() => handleCreateAssetFromTemplate(id)}
                    >
                      {name}
                    </DropdownItem>
                  );
                })}
                <Link to="assets/templates">
                  <ViewAll tag="button_template_all">view all</ViewAll>
                </Link>
              </TemplateOptions>
            )}
          </DropdownContainer>
        )}
      </ButtonContainer>
    </FlexContainer>
  );
};
export default CreateAssetButtonDropdown;
